
import { Component, Vue } from 'vue-property-decorator';
import CustomButton from '~/components/Buttons/CustomButton.vue';

@Component({ components: { CustomButton } })
export default class SetupSuccessScreen extends Vue {
  get bankLastNumbers() {
    return this.$store.getters['Account/getBankAccountLastFour'];
  }
}
